<script>
	const myHeaders = new Headers();
    myHeaders.append('Content-Type','text/csv; charset=windows-1251');

	let items = [];
	let item = false;

	fetch('https://lamptest.ru/led.php', myHeaders).then(response => {
	    return response.text();
	}).then((response) => {
	    items = response.split('\n').map(item => item.split(';')).slice(1);
	    console.log(items);
	});

	const handleClick = (i) => {
	    console.log(i);
	    item = i;
	}
</script>

<style>
    :global(body) {
        padding: 0;
        margin: 0;
    }
  main {
    font-family: sans-serif;
    text-align: center;
  }
  .table {
    display:flex;
    height: 100vh;
    overflow: hidden;
  }
  .sidebar {
    text-align: left;
    overflow-y: auto;
    width: 300px;
    min-width: 300px;
  }
  .sidebar-item {
    padding: 5px 0;
    cursor: pointer;
  }
  .content {
    text-align: left;
    padding-left: 50px;
    padding-top: 30px;
  }
  img {
    max-width: 100%;
  }
</style>

<main>
	<div class="table">
        <div class="sidebar">
            {#each items as item}
                <div class="sidebar-item" on:click="{() => handleClick(item)}">{item[1]} {item[2]}</div>
            {/each}
        </div>
        <div class="content">
            {#if (item)}
                <div>
                    <span>Brand: {item[1]}</span>
                    <br />
                    <span>Model: {item[2]}</span>
                    <div>
                        <img src={"http://lamptest.ru/images/photo/" + item[52] + ".jpg"}>
                    </div>
                </div>
            {/if}
        </div>
    </div>
</main>